import { cva, VariantProps } from 'class-variance-authority'
import { cn } from '~/lib/utils'
import { isDevelopment } from '~/utils/misc'

import StandardText, {
  StandardTextProps
} from '~/components/Text/StandardText/StandardText'

interface TextBlockProps {
  content: {
    backgroundColour: VariantProps<typeof textBlockVariants>['backgroundColour']
    technicalTexture?: Image
    contentBlock: StandardTextProps['content']
  }
  className?: string
}

const textBlockVariants = cva('', {
  variants: {
    backgroundColour: {
      'ink-blue': 'bg-blue-d text-white',
      'mid-blue': 'bg-blue-m text-white',
      'light-blue': 'bg-blue-l text-blue-d',
      chartreuse: 'bg-char text-blue-d',
      'light-pink': 'bg-pink text-blue-d',
      'light-aqua': 'bg-green text-blue-d',
      'light-purple': 'bg-purple text-blue-d',
      'light-orange': 'bg-orange text-blue-d',
      'light-grey': 'bg-grey-l text-blue-d',
      white: 'bg-white text-blue-d '
    }
  },
  defaultVariants: {
    backgroundColour: 'ink-blue'
  }
})

const TextBlock = ({ content, className }: TextBlockProps) => {
  const { backgroundColour, technicalTexture, contentBlock } = content

  const previewUrl =
    isDevelopment && !technicalTexture?.asset.sys.uri.startsWith('https')
      ? 'https://preview-websitemodern-uni-hull.cloud.contensis.com'
      : ''

  return (
    <div
      className={cn(
        textBlockVariants({ backgroundColour }),
        'space-y-m p-m sm:p-l lg:p-xl relative flex flex-col text-left',
        className
      )}
    >
      {technicalTexture && (
        <div
          className='lg:w-s w-2xs-plus sm:w-xs-plus bg-blue-d absolute top-0 left-0 h-full mix-blend-hard-light'
          style={{
            backgroundImage: `url(${previewUrl}${technicalTexture?.asset.sys.uri}?crop=24,800,center&q=75&f=webp)`,
            backgroundSize: 'cover',
            opacity: 1
          }}
        ></div>
      )}
      <StandardText
        content={contentBlock}
        backgroundColour={backgroundColour}
        className='flex grow flex-col [&_p]:max-w-[80ch]'
      />
    </div>
  )
}

export default TextBlock
